module.exports = {
  "zones": {
    "Pacific/Samoa": ["z", {
      "wallclock": -1861920000000,
      "format": "SST",
      "abbrev": "SST",
      "offset": -39600000,
      "posix": -1861879032000,
      "save": 0
    }, {
      "wallclock": -2445379200000,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": -40968000,
      "posix": -2445424632000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 45432000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {}
};